import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import ChatPage from "@/components/ai/ChatPage";
import { SEO } from "@/components/ui/seo";

/**
 * Trang chat với thiền sư AI
 */
const ChatAIPage: React.FC = () => {
  const { t } = useTranslation();
  const { expertId, chatId } = useParams();

  // Chuẩn bị context data nếu cần
  const contextData = chatId ? { chatId } : {};

  return (
    <div className="h-screen flex flex-col">
      <SEO 
        title={`${t("ai.chat_with_masters")} | Giác Ngộ`}
        description="Chat với trí tuệ nhân tạo Phật giáo, đặt câu hỏi và nhận câu trả lời từ các thiền sư ảo được huấn luyện theo giáo lý Phật giáo"
        ogType="website"
      />
      <div className="flex-1 overflow-hidden pt-0">
        <ChatPage 
          contextData={contextData}
          initialExpertId={expertId}
        />
      </div>
    </div>
  );
};

export default ChatAIPage; 